import Cache from './Cache';

export default class NamespacedCache extends Cache {
    /**
     * NamespacedCache constructor.
     * @param {string} prefix The prefix to use for the cache.
     * @param {string} type
     */
    constructor(prefix, type = 'local') {
        super(type);
        this._prefix = prefix;
    }

    /**
     * @inheritDoc
     */
    hasItem(key) {
        const data = super.getItem(this._prefix);

        if (data === null) {
            return false;
        }

        return typeof data[key] !== 'undefined';
    }

    /**
     * @inheritDoc
     */
    hasItems(keys) {
        const data = super.getItem(this._prefix);

        if (data === null) {
            return false;
        }

        for (let i = 0; i < keys.length; i++) {
            if (typeof data[keys[i]] === 'undefined') {
                return false;
            }
        }

        return true;
    }

    /**
     * @inheritDoc
     */
    getItem(key) {
        const data = super.getItem(this._prefix);

        if (data === null) {
            return null;
        } else if (typeof data[key] === 'undefined') {
            return null;
        } else {
            return data[key];
        }
    }

    /**
     * @inheritDoc
     */
    getItems(keys) {
        const items = [];
        const data = super.getItem(this._prefix);

        if (data === null) {
            return items;
        }

        keys.forEach((key) => {
            if (typeof data[key] !== 'undefined') {
                items.push(data[key]);
            }
        });

        return items;
    }

    /**
     * @inheritDoc
     */
    getAll() {
        const items = [];

        const data = super.getItem(this._prefix);

        if (data === null) {
            return items;
        }

        const keys = Object.getOwnPropertyNames(data);

        keys.forEach((key) => {
            if (typeof data[key] !== 'undefined') {
                items.push(data[key]);
            }
        });

        return items;
    }

    /**
     * @inheritDoc
     */
    setItem(key, val) {
        const data = Object.assign({}, super.getItem(this._prefix) || {});

        data[key] = val;

        super.setItem(this._prefix, data);
    }

    /**
     * @inheritDoc
     */
    setItems(data) {
        const existing = super.getItem(this._prefix) || {};

        Object.assign({}, existing, data);

        super.setItem(this._prefix, data);
    }

    /**
     * @inheritDoc
     */
    removeItem(key) {
        const data = Object.assign({}, super.getItem(this._prefix) || {});

        if (typeof data[key] !== 'undefined') {
            delete data[key];
            super.setItem(this._prefix, data);
        }
    }

    clear() {
        super.removeItem(this._prefix);
    }
}